import { Component, Input } from '@angular/core';

interface MailItem {
  read?: boolean;
  from?: string;
  dateTime?: string;
  subject?: string;
  sendingFile?: boolean;
}

@Component({
  selector: 'mapfre-mail-item',
  templateUrl: './mail-item.component.html',
  styleUrls: ['./mail-item.component.scss']
})
export class MailItemComponent {
  @Input() mail: MailItem = {};
  @Input() showSkeleton = false;

  constructor() {}
}
